import { AnalyticsPipelineEvent, TEventCategory } from '@xero/beanie-types';
import { isLocal, isUat } from '../../helpers/env';
import { BEANIE } from './constants';

export const interactionEventPayload = (
    contractId: string,
    action: string,
    eventCategory: TEventCategory,
    eventName: string,
    eventProperties: Record<string, unknown>,
    eventSource: string,
    entityType: string,
    userId?: string,
    organisationId?: string
): AnalyticsPipelineEvent => {
    const useBeanieTest = isLocal() || isUat();

    return {
        environment: useBeanieTest ? BEANIE.envTest : BEANIE.envProd,
        contractId: useBeanieTest ? BEANIE.emptyGuid : contractId,
        contractVersion: BEANIE.contractVersion,
        componentId: BEANIE.componentId,
        action,
        eventCategory,
        eventName,
        eventProperties,
        eventSource,
        entityType,
        // do not send default guid or null ids to beanie in prod
        ...(isLocal() ? { userId: BEANIE.emptyGuid } : userId !== undefined ? { userId } : {}),
        ...(isLocal() ? { organisationId: BEANIE.emptyGuid } : organisationId !== undefined ? { organisationId } : {}),
        isAnonymousEvent: !userId ? true : false,
    };
};
